import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import debounce from 'lodash/debounce';

import * as themes from '../../constants/theme';
import withTheme from '../withTheme/withTheme';

import './header.scss';

class Header extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            height: 80,
        };

        this.headerRef = React.createRef();

        this.setHeight = this.setHeight.bind(this);
        this.debouncedHeightSet = debounce(this.setHeight.bind(this), 100);
    }

    componentDidMount() {
        this.setHeight();

        window.addEventListener('resize', this.debouncedHeightSet);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.debouncedHeightSet);
    }

    setHeight() {
        const node = this.headerRef.current;

        this.setState({
            height: node.offsetHeight,
        });
    }

    render() {
        const { children, theme } = this.props;
        const { height } = this.state;
        const headerClassName = classNames('header', {
            [`header--${theme}`]: true,
        });

        const indicatorStyles = {
            height: `${height > 80 ? height : 80}px`,
            minHeight: `${height > 80 ? height : 80}px`,
        };

        return (
            <React.Fragment>
                <header
                    className={headerClassName}
                    ref={this.headerRef}
                >
                    <div className="header__frame">
                        {children}
                    </div>
                </header>
                <div aria-hidden="true" className="header__indicator" style={indicatorStyles} />
            </React.Fragment>
        );
    }
}

Header.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    theme: PropTypes.oneOf(Object.values(themes)),
};

Header.defaultProps = {
    children: null,
    theme: themes.PRIVATE,
};

export const ThemedHeader = withTheme(Header);

export default Header;
